/** mock transaction functions */
export const pseudoTransactionFunctions = {
    changeUserRole: async (user) => {
        console.log(`changeUserRole, user`, user);
    },
    deleteObject: async (ob) => {
        console.log(`deleteObject, ob`, ob);
    },
    getAdjacent: async (ob, type, direction) => {
        console.log(`getAdjacent, ob`, { ob, type, direction });
        return [];
    },
    getObject: async (ob) => {
        console.log(`getObject, ob`, { ob });
        return ob;
    },
    link: async (parent, child) => {
        console.log(`link`, { parent, child });
        return [parent, undefined, child];
    },
    linkObjectsToPrimary: async (parentObject, childObjects, adjacentFilter) => {
        console.log(`linkObjectsToPrimary,`, { parentObject, childObjects, adjacentFilter });
    },
    requestUploadFile: async (directory, file) => {
        console.log(`requestUploadFile,`, { directory, file });
    },
    saveAndLinkObject: async (existingObjectSk, newObject, adjacentFilter) => {
        console.log(`saveAndLinkObject,`, { existingObjectSk, newObject, adjacentFilter });
    },
    saveObject: async (ob) => {
        console.log(`saveObject, ob`, ob);
    },
    searchByType: async (contextObject, includeContextLinkedItems, typeId) => {
        console.log(`searchByType,`, { contextObject, includeContextLinkedItems, typeId });
    },
    unlink: async (zombieA, zombieB, edgeTypeId, edgeAttributes) => {
        console.log(`unlink,`, { zombieA, zombieB, edgeTypeId, edgeAttributes });
    },
};
